import D2C_Instance from '../Instance'

class D2C_InstanceVultr extends D2C_Instance {
  static active = true
  static objectType = 'instanceType'
  static providerType = 'Vultr'
}

export default D2C_InstanceVultr
